import React, { useState, useRef } from 'react';
import './LivingRoom.css';
import Plaque from './Plaque';

function LivingRoom({ data = [], artistBios, plaqueRefs }) {
  const [collageLoaded, setCollageLoaded] = useState(false);

  const currentlyPlayingVideo = useRef(null);
  
    const handleVideoPlay = (videoEl) => {
      if (currentlyPlayingVideo.current && currentlyPlayingVideo.current !== videoEl) {
        currentlyPlayingVideo.current.pause();
      }
      currentlyPlayingVideo.current = videoEl;
    };

  return (
    <div>
      <div 
          className="collage-wrapper"
          style={{ position: 'relative' }}
          ref={(el) => (plaqueRefs.current[-1] = el)}
      >
        {!collageLoaded && (
          <div className="spinner-wrapper">
            <div className="spinner" />
          </div>
        )}

        <picture>
            <source
                media="(max-width: 768px)"
                srcSet="/collages/living_room_collage_mobile_result.webp"
            />
            <img
                className="livingRoomTiles"
                alt="living-room-tiles"
                loading="lazy"
                src="/collages/living_room_collage_result.webp"
                onLoad={() => setCollageLoaded(true)}
            />
        </picture>
      </div>

      {data.map((piece, index) => (
          <div
              key={index}
              className="art-piece"
              ref={(el) => (plaqueRefs.current[index] = el)}
          >
              <Plaque piece={piece} artistBios={artistBios} nameClickable={true} onVideoPlay={handleVideoPlay} />
          </div>
      ))}
    </div>
  );
}

export default LivingRoom;
